export default __webpack_public_path__ + "static/media/Screenshot6.48921228.png";